import { render, staticRenderFns } from "./addCustom.vue?vue&type=template&id=4855fc46&scoped=true"
import script from "./addCustom.vue?vue&type=script&lang=js"
export * from "./addCustom.vue?vue&type=script&lang=js"
import style0 from "./addCustom.vue?vue&type=style&index=0&id=4855fc46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855fc46",
  null
  
)

export default component.exports